// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c7c60463","453":"49231d30","455":"cded3a2a","977":"a8cd084a"}[chunkId] + ".chunk.js";
};